import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Selector({ products, category, loading }) {
  const [questions, setQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  useEffect(() => {
    fetchQuestions();
  }, []);

  const fetchQuestions = async () => {
    try {
      const response = await axios.get('/api/questions/');
      const data = Array.isArray(response.data) ? response.data : response.data.results || [];
      setQuestions(data);
    } catch (error) {
      console.error('Error fetching questions:', error);
      setQuestions([]);
    }
  };

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;
  }

  return (
    <div id="sl">
      <div style={{ marginBottom: '16px' }}>
        <h3 style={{ 
          fontSize: '13px', 
          fontWeight: '700', 
          marginBottom: '8px', 
          color: '#374151' 
        }}>
          Product Selector - Answer questions to find the right product
        </h3>
        <p style={{ fontSize: '10px', color: '#6B7280', marginBottom: '12px' }}>
          Select a question below to see the recommended product
        </p>
      </div>

      <div className="SG">
        {questions.map((question, idx) => (
          <div
            key={question.id}
            className="si"
            onClick={() => setSelectedQuestion(question)}
            style={{
              borderColor: selectedQuestion?.id === question.id ? '#1B3A5C' : '#E5E7EB',
              background: selectedQuestion?.id === question.id ? '#F8FAFC' : '#FAFBFC',
              cursor: 'pointer'
            }}
          >
            <div style={{ flex: 1 }}>
              <div style={{ 
                fontSize: '8px', 
                fontWeight: '600', 
                color: '#9CA3AF', 
                marginBottom: '2px' 
              }}>
                Q{idx + 1}
              </div>
              <div style={{ fontSize: '10px', fontWeight: '600', color: '#374151' }}>
                {question.question_text}
              </div>
            </div>
            <div style={{
              fontSize: '18px',
              color: selectedQuestion?.id === question.id ? '#1B3A5C' : '#D1D5DB'
            }}>
              →
            </div>
          </div>
        ))}
      </div>

      {selectedQuestion && selectedQuestion.answer_product_data && (
        <div style={{ marginTop: '16px' }}>
          <div style={{
            padding: '12px 14px',
            background: '#EFF6FF',
            border: '2px solid #BFDBFE',
            borderRadius: '8px',
            marginBottom: '12px'
          }}>
            <div style={{ fontSize: '9px', fontWeight: '700', color: '#1D4ED8', marginBottom: '4px' }}>
              RECOMMENDED PRODUCT
            </div>
            <div style={{ fontSize: '14px', fontWeight: '800', color: '#111827' }}>
              {selectedQuestion.answer_product_data.code} - {selectedQuestion.answer_product_data.name}
            </div>
          </div>

          <div className="C" style={{ display: 'block', cursor: 'default' }}>
            <div style={{ 
              height: '3px', 
              background: selectedQuestion.answer_product_data.color 
            }}></div>
            <div style={{ padding: '12px 14px' }}>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'flex-start', 
                marginBottom: '6px' 
              }}>
                <div>
                  <div style={{ 
                    fontSize: '8px', 
                    fontWeight: '700', 
                    color: selectedQuestion.answer_product_data.color, 
                    letterSpacing: '1px', 
                    textTransform: 'uppercase' 
                  }}>
                    {selectedQuestion.answer_product_data.package_number}
                  </div>
                  <div style={{ fontSize: '14px', fontWeight: '800', color: '#111827' }}>
                    {selectedQuestion.answer_product_data.code}
                  </div>
                  <div style={{ fontSize: '10px', color: '#6B7280' }}>
                    {selectedQuestion.answer_product_data.name}
                  </div>
                </div>
                <div style={{ 
                  padding: '2px 6px', 
                  borderRadius: '4px', 
                  background: `${selectedQuestion.answer_product_data.color}10`, 
                  border: `1px solid ${selectedQuestion.answer_product_data.color}20`, 
                  fontSize: '9px', 
                  fontWeight: '700', 
                  color: selectedQuestion.answer_product_data.color, 
                  whiteSpace: 'nowrap' 
                }}>
                  {selectedQuestion.answer_product_data.api_spec}
                </div>
              </div>
              <p style={{ 
                fontSize: '9px', 
                color: '#4B5563', 
                lineHeight: '1.4', 
                margin: '0 0 8px', 
                fontStyle: 'italic' 
              }}>
                {selectedQuestion.answer_product_data.description}
              </p>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: '1fr 1fr 1fr 1fr', 
                gap: '4px' 
              }}>
                <div style={{ padding: '4px 5px', background: '#F9FAFB', borderRadius: '4px' }}>
                  <div style={{ fontSize: '6px', color: '#9CA3AF', fontWeight: '600' }}>TBN</div>
                  <div style={{ 
                    fontSize: '12px', 
                    fontWeight: '800', 
                    color: '#111827', 
                    fontFamily: 'monospace' 
                  }}>
                    {selectedQuestion.answer_product_data.tbn}
                  </div>
                </div>
                <div style={{ padding: '4px 5px', background: '#F9FAFB', borderRadius: '4px' }}>
                  <div style={{ fontSize: '6px', color: '#9CA3AF', fontWeight: '600' }}>TREAT</div>
                  <div style={{ 
                    fontSize: '12px', 
                    fontWeight: '800', 
                    color: '#111827', 
                    fontFamily: 'monospace' 
                  }}>
                    {selectedQuestion.answer_product_data.treat_rate}%
                  </div>
                </div>
                <div style={{ padding: '4px 5px', background: '#F9FAFB', borderRadius: '4px' }}>
                  <div style={{ fontSize: '6px', color: '#9CA3AF', fontWeight: '600' }}>ASH</div>
                  <div style={{ 
                    fontSize: '12px', 
                    fontWeight: '800', 
                    color: '#111827', 
                    fontFamily: 'monospace' 
                  }}>
                    {selectedQuestion.answer_product_data.ash || '—'}
                  </div>
                </div>
                {selectedQuestion.answer_product_data.tbn_in_oil && selectedQuestion.answer_product_data.tbn_in_oil > 0 && (
                  <div style={{ 
                    padding: '4px 5px', 
                    background: '#FEF3C7', 
                    borderRadius: '4px', 
                    border: '1px solid #FDE68A' 
                  }}>
                    <div style={{ fontSize: '6px', color: '#92400E', fontWeight: '600' }}>
                      TBN IN OIL
                    </div>
                    <div style={{ 
                      fontSize: '12px', 
                      fontWeight: '800', 
                      color: '#92400E', 
                      fontFamily: 'monospace' 
                    }}>
                      {selectedQuestion.answer_product_data.tbn_in_oil}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {questions.length === 0 && (
        <div style={{
          padding: '40px 20px',
          textAlign: 'center',
          color: '#9CA3AF',
          fontSize: '12px'
        }}>
          No questions available. Add questions in the admin panel.
        </div>
      )}
    </div>
  );
}

export default Selector;
